import config from 'src/config'

function load(component) {
  return () => import(`src/${component}.vue`)
}

const MODULE_PATH = '/inventory/'

export default [
  {
    path: MODULE_PATH,
    component: load('containers/Full'),
    redirect: MODULE_PATH + 'management',
    name: 'Inventory',
    meta: {
      title: 'Common.menu.inventory_management',
      menuItem: true,
      sorting: config.sidebar.menu.sorting.modules.inventory,
      icon: 'list_alt',
      handicap: true,
    },
    children: [
      {
        path: MODULE_PATH + 'management',
        component: load('application/inventory/components/InventoryManagement'),
        name: 'Inventory Management',
        meta: {
          title: 'Common.menu.inventory_management',
          icon: 'attach_money',
          menuItem: true,
          sorting: 901,
        },
      },
    ],
  },
]
